import {
  request,
  requestJson,
  response,
  requestGetMethod,
  responseLoyaltyWS,
  requestLoyaltyWS,
  requestPostUrl,
} from './functions';

export function onSearchChallengeDetailServ(challenge) {
  const req = request('ePOS00430566');
  return response('admin/switchUsermode', req);
}

export function onUpdatePasswordServ(obj) {
  const req = requestJson(obj);
  return response('user/updatePassword', req);
}

export function onUpdateAgentNumberServ(obj) {
  const req = requestJson(obj);
  return response('user/updateAgentNumber', req);
}

export function searchAgentInfoServ(userCode) {
  const req = request(userCode);
  return response('user/searchAgentInfo', req);
}

export function searchAgentInfoNameServ(agentName) {
  const req = request(agentName);
  return response('user/searchAgentName', req);
}

export function searchAgentInfoServCode(userCode) {
  const req = request(userCode);
  return response('user/searchAgentCode', req);
}

export function getAllQuestServ(obj) {
  const req = requestJson(obj);
  return response('loyalty/getAllQuest', req);
}

export function getSearchTransactionDetailServ(obj) {
  const req = requestLoyaltyWS('POST', {}, obj);
  return responseLoyaltyWS('loyalty/Transactions/GetTransactionPointHistory', req);
}

export function getAllRewardServ(userCode) {
  userCode = '';
  const req = requestGetMethod(userCode);
  return response('loyalty/GiftCategory/GetAll', req);
}

export function getByGiftGroupServ() {
  // userCode = '';
  const req = requestGetMethod();
  return response('loyalty/GiftGroupDetails/GetByGiftGroup', req);
}

export function getGiftInforsServ(category) {
  // userCode = '';
  const req = request(category);
  return response('loyalty/GiftInfors/GetAllForCategory', req);
}

export function getAllWithImageServ() {
  // userCode = '';
  const req = requestGetMethod();
  return response('loyalty/GiftGroups/GetAllWithImage', req);
}

export function getGiftDetailByGroupServ() {
  // userCode = '';
  const req = requestGetMethod();
  return response('loyalty/GiftGroupDetails/GetByGiftGroup', req);
}

export function getQuestAllServ(resQuest) {
  const req = request(resQuest);
  return response('loyalty/getAllQuest', req);
}

export function getProfileByCServ(userCode) {
  const req = requestLoyaltyWS('GET', { code: userCode });
  return responseLoyaltyWS('loyalty/SecondaryCustomers/GetProfileByCode', req);
}

export function getListMyGiftStore(eposGiftInfofr) {
  const req = request(eposGiftInfofr);
  return response('loyalty/GiftInfors/GetAllByMemberCode', req);
}

export function getRedeemTokenServ(obj) {
  const req = requestLoyaltyWS('POST', {}, obj);
  return responseLoyaltyWS('loyalty/GiftTransactions/CreateRedeemTransaction', req);
}

export function getListMyGiftGroupStore(eposGiftInfofr) {
  const req = requestLoyaltyWS('POST', {}, eposGiftInfofr);
  return responseLoyaltyWS('loyalty/GiftInfors/getGiftGroupCodeFilter', req);
}

export function genLinkBhbv(eposGiftInfofr) {
  const req = request(eposGiftInfofr);
  return response('minigame/v1/bhbv/genLinkBhbv', req);
}

export function logoutServ() {
  const req = request({});
  return response('/v2/log/logout', req);
}
